import { DOCUMENTS_TYPES } from '../../FileUpload/FileUpload.constants';

export const NAMES = {
  FIAS_VALUE: 'fiasValue',
  REGISTRATION_DATE: 'regDate',
  INDEX: 'index',
  LIVING_ADDRESS_EQUALS: 'livingAddressEquals',
  REALTY_STATE: 'realtyState',
};

export const ADDRESS_DOCUMENTS = [
  DOCUMENTS_TYPES.PASSPORT_REGISTRATION,
  DOCUMENTS_TYPES.PASSPORT_REGISTRATION_HANDWRITTEN,
];

export const ADDRESS_FORM_LABELS = {
  [NAMES.FIAS_VALUE]: 'Адрес',
  [NAMES.INDEX]: 'Индекс',
  [NAMES.REGISTRATION_DATE]: 'Дата регистрации',
  [NAMES.LIVING_ADDRESS_EQUALS]: 'Совпадает с адресом проживания',
  [NAMES.REALTY_STATE]: 'Недвижимость в собственности',
};
